module.exports = __webpack_public_path__ + "img/water-graph.cd1b5f2d.png";